var map = {
	"./customer10_BR1_1.json": 8364,
	"./customer10_BR3_1.json": 8232,
	"./customer10_BR7_1.json": 7053,
	"./customer1_BR1_1.json": 5279,
	"./customer1_BR3_1.json": 6907,
	"./customer1_BR7_1.json": 98,
	"./customer2_BR1_1.json": 5238,
	"./customer2_BR3_1.json": 4599,
	"./customer2_BR7_1.json": 2884,
	"./customer5_BR1_1.json": 811,
	"./customer5_BR2_1.json": 3478,
	"./customer5_BR3_1.json": 9354,
	"./customer5_BR4_1.json": 317,
	"./customer5_BR5_1.json": 3304,
	"./customer5_BR6_1.json": 2683,
	"./customer5_BR7_1.json": 4267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3526;